import { CellPlugin } from '@react-page/editor';
import * as React from 'react';
import { useEffect, useState } from 'react';
import { Modal } from 'react-bootstrap';
import { useDispatch } from 'react-redux';
import { cancelOrderAction, PROCESS_ORDER_REQUEST, PROCESS_ORDER_SUCCESS } from '../../../../../redux/actions/orderManagement';
import store from '../../../../../redux/store';
import { IActionResult } from '../../../../../redux/storeTypes';

type Data = {
    titleLabel: string,
    subTitleLabel: string,
    infoLabel: string,
    sessionLimit: number;
    margin: string,
    padding: string,
}

const MARGIN = '0px';
const PADDING = '0px';

const SessionLimiterPlugin: CellPlugin<Data> = {
    Renderer: ({ data }) => {
        const dispatch = useDispatch();
        const [delay, setDelay] = useState(-1);
        const [show, setShow] = useState(false);
        const minutes = Math.floor(delay / 60);
        const seconds = Math.floor(delay % 60);
        const checkProgress = (async () => {
            let actionResult;
            do {
                await new Promise((resolve) => setTimeout(resolve, 3000));
                actionResult = store.getState().orderManagement.actionResult! as IActionResult;
                if (!(actionResult && actionResult?.type === PROCESS_ORDER_REQUEST && !actionResult.result)) {
                    break;
                }
            } while (true);
            if (!(actionResult && actionResult?.type === PROCESS_ORDER_REQUEST && actionResult.result === PROCESS_ORDER_SUCCESS)) {
                dispatch(cancelOrderAction(""));
            }
        });
        useEffect(() => {
            if (data?.sessionLimit > 0) {
                setDelay(data.sessionLimit);
            }
        }, [data]);
        useEffect(() => {
            if (delay >= 0) {
                const timer = setInterval(() => {
                    setDelay(delay - 1);
                }, 1000);
                if (delay === 0) {
                    setShow(true);
                    clearInterval(timer);
                    setTimeout(() => {
                        let actionResult = store.getState().orderManagement.actionResult! as IActionResult;
                        if (actionResult && actionResult?.type === PROCESS_ORDER_REQUEST && !actionResult.result) {
                            checkProgress();
                        } else {
                            if (!(actionResult && actionResult?.type === PROCESS_ORDER_REQUEST && actionResult.result === PROCESS_ORDER_SUCCESS)) {
                                dispatch(cancelOrderAction(""));
                            }
                        }
                    }, 3000);
                }
                return () => {
                    clearInterval(timer);
                };
            }
        // eslint-disable-next-line react-hooks/exhaustive-deps
        }, [delay]);
        return (
            <>
                <Modal show={show} onHide={() => setShow(false)} backdrop="static" className="modal-confirmation">
                    <Modal.Body>
                        <div className="confirmation-body">
                            <p>
                                Ending payment session! Please wait...
                            </p>
                        </div>
                    </Modal.Body>
                </Modal>
                {delay >= 0 && <div style={{ margin: data.margin, padding: data.padding, alignItems: 'flex-end' }}>
                        <div className="text-center">
                            <div>{data.titleLabel}</div>
                            <div></div><small className="text-muted">{data.subTitleLabel}</small>
                            <div><big style={{ color: 'red' }}><b>{(minutes > 0) ? minutes + ' minute' + ((minutes > 1) ? 's' : '') : ''} {seconds} seconds</b></big></div>
                            <em><small className="text-muted"> {data.infoLabel} </small></em>
                        </div>
                </div>}
            </>
        );
    },
    id: 'SessionLimiterPlugin',
    title: 'Session Limiter',
    description: 'Add a session limiter component and define its items.',
    version: 1,
    controls: [
        {
            title: 'Labels',
            controls: {
                type: 'autoform',
                schema: {
                    properties: {
                        titleLabel: {
                            type: 'string',
                            default: 'Payment Session Timer',
                        },
                        subTitleLabel: {
                            type: 'string',
                            default: 'This payment session ends in ...',
                        },
                        infoLabel: {
                            type: 'string',
                            default: 'Complete payment transaction as soon as possible',
                        },
                        sessionLimit: {
                            type: 'number',
                            default: 900,
                        },
                    },
                    required: [],
                },
            },
        },
        {
            title: 'Styles',
            controls: {
                type: 'autoform',
                schema: {
                    properties: {
                        margin: {
                            type: 'string',
                            default: MARGIN,
                        },
                        padding: {
                            type: 'string',
                            default: PADDING,
                        },
                    },
                    required: [],
                },
            },
        },
    ]
};

export default SessionLimiterPlugin;